"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Portal_1 = require("./Portal");
exports.default = Portal_1.default;
//# sourceMappingURL=index.js.map